import { gql } from "@apollo/client";

const CREATE_CLASSROOM = gql`mutation CreateClassroom($name: String!, $gradeUid: UUID!) {
  createClassroom(input: { classroom: { name: $name, gradeUid: $gradeUid } }) {
    classroom {
      uid
      createdBy
      organizationUid
      name
    }
  }
} `;

const LIST_CLASSROOMS = gql`query GetClassrooms($first: Int = 100, $offset: Int = 0, $filter: ClassroomFilter){
  allClassrooms(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [NAME_ASC]) {
    nodes {
      uid
      name
      organizationUid
      gradeByGradeUid {
        name
        uid
      }
      usersByClassroomUid {
        nodes {
          uid
        }
        totalCount
      }
    }
    totalCount
  }
} `;

const LIST_CLASSROOMS_FOR_ADMIN = gql`query  ListClassroomsForAdmin( $first: Int = 100, $offset: Int = 0, $filter: ClassroomFilter) {
  listClassroomsForAdmin(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [NAME_ASC]) {
    nodes {
      uid
      name
      organizationUid
      gradeByGradeUid {
        name
        uid
      }
      usersByClassroomUid {
        nodes {
          uid
        }
        totalCount
      }
    }
    totalCount
  }
}
`;

const CREATE_ADMIN_CLASSROOM = gql`mutation CreateAdminClassroom($classroomUid: UUID!, $userUid: UUID!) {
  createAdminClassroom(input: { adminClassroom: { classroomUid: $classroomUid, userUid: $userUid } }) {
    clientMutationId
  }
}
`;

const DELETE_CLASSROOM = gql`mutation DeleteClassroom($classroomUid: UUID!) {
  deleteClassroomByUid(input: { uid: $classroomUid }){
    classroom{
      uid
      name
    }
  }
}
`;

const DELETE_ADMIN_CLASSROOM = gql`mutation DeleteAdminClassroom($classroomUid: UUID!, $userUid: UUID!) {
  deleteAdminClassroomByUserUidAndClassroomUid(input: { classroomUid: $classroomUid, userUid: $userUid }) {
    clientMutationId
  }
}
`;

const GET_CLASSROOM = gql`query GetClassroom($classroomUid: UUID!){
  classroomByUid(uid: $classroomUid){
    name
    uid
    usersByClassroomUid {
      nodes {
        firstName
        uid
        lastName
      }
    }
  }
} `;

export {
  CREATE_CLASSROOM,
  LIST_CLASSROOMS,
  LIST_CLASSROOMS_FOR_ADMIN,
  CREATE_ADMIN_CLASSROOM,
  DELETE_CLASSROOM,
  DELETE_ADMIN_CLASSROOM,
  GET_CLASSROOM,
};
